export function getAll() {
  return [
    {
      value: 0,
      name: "Select",
      text: "手動選擇商品",
    },
    {
      value: 3,
      name: "Optional",
      text: "手動選擇商品（非必選）",
    },
    {
      value: 1,
      name: "LowestPrice",
      text: "最低價",
    },
    {
      value: 2,
      name: "HighestPrice",
      text: "最高價",
    },
  ];
}
export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
